import FlyBalls from './_components/flyball';
import {WhiteSpace, WingBlank,Modal} from 'antd-mobile';
import './Footer.css';
import CONF_LAN from "./config/LAN";
import React from "react";
let flyBalls=undefined;
//TCSS相关方法，暂时放到这里
//动态生成JS或CSS
function delay_js(url) {
    var type = url.split("."), file = type[type.length - 1];
    if (file == "css") {
        var obj = document.createElement("link"), lnk = "href", tp = "text/css";
        obj.setAttribute("rel", "stylesheet");
    } else var obj = document.createElement("script"), lnk = "src", tp = "text/javascript";
    obj.setAttribute(lnk, url);
    obj.setAttribute("type", tp);
    file == "css" ? document.getElementsByTagName("head")[0].appendChild(obj) : document.body.appendChild(obj);
    return obj;
}

//延迟加载
function addload(func) {
    var old = window.onload;
    if (typeof window.onload != "function") {
        window.onload = func;
    } else {
        window.onload = function () {
            old();
            func();
        }
    }
};

function loadjs(url, succ, v) {
    var elem = delay_js(url);
    if ((navigator.userAgent.indexOf('MSIE') == -1) ? false : true) {
        elem.onreadystatechange = function () {
            if (this.readyState && this.readyState == "loading") return; else succ(v);
        };
    } else elem.onload = function () {
        succ(v);
    };
    elem.onerror = function () {
    };
};
function MyTcss() {
    if (typeof(pgvMain) == 'function' && !window.hasPgvMainDone){
        if(window.location.hash && ["#/next","#/career"].includes(window.location.hash)){
            //对于这些测试单页面应用
            pgvMain({repeatApplay: "true",virtualDomain: "thenextstudio.qq.com",virtualURL:('m'+window.location.hash.substr(1)+'_'+CUR_LAN)});
            window.hasPgvMainDone=true;//页面刷新，只上报一次，后续再路由跳转的时候手动上报
        }
        //博客详情上报
        else if(window.location.href.indexOf('blogdetail.html')>0){
            //获取信息id
            var iid=window.location.href.substr(window.location.href.lastIndexOf('/')+1).split('.')[0];
            pgvMain({virtualDomain: "thenextstudio.qq.com",virtualURL:('m'+'_blogdetail'+'_'+CUR_LAN+'?infoid='+iid)});
            window.hasPgvMainDone=true;
        }
        //新闻详情上报
        else if(window.location.href.indexOf('newsdetail.html')>0){
            //获取信息id
            var iid=window.location.href.substr(window.location.href.lastIndexOf('/')+1).split('.')[0];
            pgvMain({virtualDomain: "thenextstudio.qq.com",virtualURL:('m'+'_newsdetail'+'_'+CUR_LAN+'?infoid='+iid)});
            window.hasPgvMainDone=true;
        }
        else{
            pgvMain({virtualDomain: "thenextstudio.qq.com"});//千万不能忘记！;
            window.hasPgvMainDone=true;
        }
    }
}

var tcssurl = '//pingjs.qq.com/tcss.ping.js';
var protocolStr = document.location.protocol;
if (protocolStr == "https:") {
    tcssurl = '//pingjs.qq.com/tcss.ping.https.js';
}

class FooterComp extends React.Component {
    constructor(props) {
        super(props);

    }
    componentDidMount() {
        if(!flyBalls){
            flyBalls=new FlyBalls(this.refs['footer-outer'],'footer-canvas');
            this.refs['footer-outer'].style.position='relative';
            flyBalls.Run();
        }
        if(PAGE_DATA['isloadtcss']){
            if(window.PAGENOTCSS!==true){
                loadjs(tcssurl, MyTcss);
                //tcss统计 开始
                var tcssDoms=$('[data-ptt]');
                $(tcssDoms).css('cursor','pointer');
                $(tcssDoms).off('click').on('click',function(){
                    var pt=$(this).attr('data-ptt');
                    try { pgvSendClick({hottag:pt,virtualDomain: "thenextstudio.qq.com"}); }catch (e){}
                })
                //tcss统计 结束
            }
        }

    }
    render() {
        return (
            <div ref={'footer-outer'} className={'footer-comp-outer'}>
                <WingBlank size="sm">
                    <img className={"slogan-img"} src={CONF_LAN[CUR_LAN]['img_dir']+'Slogan.png'} />
                    <div className={'copyright'}>
                        <span>
                            <font>
                                COPYRIGHT &copy; 2017-{new Date().getFullYear()} {COMPANY_NAME}
                            </font>
                        </span>
                        <span>
                            <font>
                                 ALL RIGHTS RESERVED.
                            </font>
                        </span>
                    </div>
                </WingBlank>
            </div>
        );
    }
}
export default  FooterComp;